/**
 * Product Manager Filtering Configuration
 * Configures filtering settings for product lists
 */

// Initialize ProductManager namespace
const ProductManager = window.ProductManager || {}
ProductManager.settings = ProductManager.settings || {}

// Get filtering configuration from data attributes
const getFilteringConfig = () => {
	const container = document.querySelector('.tx-pxa-product-manager')

	// Parse filtersAvailableOptions from data attribute
	let filtersAvailableOptions = {}
	try {
		const optionsData = container?.dataset.filtersAvailableOptions
		if (optionsData) {
			filtersAvailableOptions = JSON.parse(optionsData)
		}
	} catch (e) {
		console.error('Failed to parse filtersAvailableOptions:', e)
	}

	return {
		selectBoxes: '.tx-pxa-product-manager [data-filter-type]',
		updateButton: '.tx-pxa-product-manager [data-update-filter]',
		filterButtons: '.tx-pxa-product-manager [data-exec-filter]',
		filtersAvailableOptions: filtersAvailableOptions,
	}
}

// Set configuration
ProductManager.settings.filtering = getFilteringConfig()

// Export to window
window.ProductManager = ProductManager
